import { render, staticRenderFns } from "./CalendarVue.vue?vue&type=template&id=72aa9b8e&"
import script from "./CalendarVue.vue?vue&type=script&lang=js&"
export * from "./CalendarVue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports